import { IElementTypeEditInfo } from './../models/index'

export const hotTextEditInfo = {
    editExcludeFields: []
}